import { render, staticRenderFns } from "./WaitingListDetails.vue?vue&type=template&id=5c8bc31c&scoped=true&"
import script from "./WaitingListDetails.vue?vue&type=script&lang=ts&"
export * from "./WaitingListDetails.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingListDetails.vue?vue&type=style&index=0&id=5c8bc31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8bc31c",
  null
  
)

export default component.exports